"use client";
import styles from './SlideOne.module.css';
import React, { useState, useRef, useEffect } from "react";
import { useRouter } from "next/router";
import Buttons from '../../Button/Button';
import TextSlider from './TextSlider/TextSlider';


const SlideOne = () => {
  const router = useRouter()
  return (
    <>
      <div className={styles.BannerContent} style={{
        background: `url("https://cdn.mytakbir.com/static-assets/images/takbir-website-hoome-section-background.webp`,
      }}>

        <div className={styles.Container}>
          <div className={styles.Title}>One place to learn</div>
          <div className={styles.SubTitle}>
            {/* <TextSlider /> */}
            the chosen Deen
          </div>
          <div className={styles.Description}>#1 site for learners and teachers for <br></br>the knowledge of Islam</div>


          <div className={styles.ButtonBox}>
            <button
              className={styles.BottomButton}
              onClick={() => router.push("/search")}
            >
              Explore Courses
            </button>
          </div>
          
        </div>
      </div>

    </>
  );
};

export default SlideOne;
